// extracted by mini-css-extract-plugin
module.exports = {"group_8":"countryResponse_group_8__3AG1d","group_9":"countryResponse_group_9__BMAlo"};